<component v-if="shouldRenderConfig" v-bind:is="getContainerType" v-bind:class="getClassName">
        <appPacking3dBackward></appPacking3dBackward>
        <appPacking3dForward></appPacking3dForward>
</component>